import React, { useState } from 'react';
import {
  Box,
  SpaceBetween,
  Select,
  Grid,
  Button
} from '@amzn/awsui-components-react';
import HourlyTab from './HourlyTab';

const Val = ({ children }) => <Box variant="span" fontWeight="bold">{children}</Box>;

const MonthlyTab = ({ isViewMode, onConfigChange, initialConfig = {} }) => {
  const [monthlyCalendarDayValue, setMonthlyCalendarDayValue] = useState('1');
  const [monthlyCalendarDayMonths, setMonthlyCalendarDayMonths] = useState('1');
  const [showHourlyConfig, setShowHourlyConfig] = useState(false);
  const [hourlyConfig, setHourlyConfig] = useState({});

  // Initialize from config
  React.useEffect(() => {
    if (Object.keys(initialConfig).length > 0) {
      setMonthlyCalendarDayValue(initialConfig.calendarDayValue || '1');
      setMonthlyCalendarDayMonths(initialConfig.calendarDayMonths || '1');
      setShowHourlyConfig(!!initialConfig.hourlyConfig);
      setHourlyConfig(initialConfig.hourlyConfig || {});
    }
  }, [initialConfig]);

  const handleConfigChange = (overrides = {}) => {
    onConfigChange({
      calendarDay: true,
      calendarDayValue: monthlyCalendarDayValue,
      calendarDayMonths: monthlyCalendarDayMonths,
      hourlyConfig: showHourlyConfig ? hourlyConfig : null,
      ...overrides
    });
  };

  if (isViewMode) {
    return (
      <SpaceBetween size="s">
        <Box>
          <Box variant="awsui-key-label">Day type</Box>
          <Val>Calendar day</Val>
        </Box>
        <Box>
          <Box variant="awsui-key-label">Day</Box>
          <Val>{monthlyCalendarDayValue}</Val>
        </Box>
        <Box>
          <Box variant="awsui-key-label">Every (months)</Box>
          <Val>{monthlyCalendarDayMonths}</Val>
        </Box>
        {showHourlyConfig && hourlyConfig && Object.keys(hourlyConfig).length > 0 && (
          <Box>
            <Box variant="awsui-key-label">Hourly configuration</Box>
            <HourlyTab isViewMode={true} onConfigChange={() => {}} initialConfig={hourlyConfig} />
          </Box>
        )}
      </SpaceBetween>
    );
  }

  return (
    <SpaceBetween size="m">
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 2 }, { colspan: 2 }, { colspan: 2 }, { colspan: 3 }]}>
        <Box padding={{ top: 'xs' }}>Calendar day</Box>
        <Select
          selectedOption={{ label: monthlyCalendarDayValue, value: monthlyCalendarDayValue }}
          onChange={({ detail }) => { setMonthlyCalendarDayValue(detail.selectedOption.value); handleConfigChange({ calendarDayValue: detail.selectedOption.value }); }}
          options={[...Array(31)].map((_, i) => ({ label: String(i + 1), value: String(i + 1) }))}
          disabled={isViewMode}
        />
        <Box padding={{ top: 'xs' }}>of every</Box>
        <Select
          selectedOption={{ label: monthlyCalendarDayMonths, value: monthlyCalendarDayMonths }}
          onChange={({ detail }) => { setMonthlyCalendarDayMonths(detail.selectedOption.value); handleConfigChange({ calendarDayMonths: detail.selectedOption.value }); }}
          options={[...Array(12)].map((_, i) => ({ label: String(i + 1), value: String(i + 1) }))}
          disabled={isViewMode}
        />
        <Box padding={{ top: 'xs' }}>months</Box>
      </Grid>

      <Box>
        <Button
          variant="normal"
          onClick={() => { setShowHourlyConfig(!showHourlyConfig); handleConfigChange({ hourlyConfig: !showHourlyConfig ? hourlyConfig : null }); }}
          disabled={isViewMode}
        >
          {showHourlyConfig ? 'Hide' : 'Add'} Hourly Configuration
        </Button>
      </Box>

      {showHourlyConfig && (
        <Box padding={{ left: 'l' }}>
          <Box variant="h3">Hourly Configuration</Box>
          <HourlyTab
            isViewMode={isViewMode}
            onConfigChange={(config) => { setHourlyConfig(config); handleConfigChange({ hourlyConfig: config }); }}
            initialConfig={initialConfig.hourlyConfig || { option: 'interval', interval: '1', selectedHours: [], rangeStart: '9', rangeEnd: '17', specificMinute: '0' }}
          />
        </Box>
      )}
    </SpaceBetween>
  );
};

export default MonthlyTab;
